module.exports = __webpack_public_path__ + "static/media/bg_newsletter.dc694841.png";